import type { CmsMediaFile, CmsMediaFileId } from '#shared/types/cms'
import type { UserId } from '#shared/types/users'
import type { AbstractId } from '#shared/types/utils'
import type { Dayjs } from 'dayjs'

export type DonationId = AbstractId<'donation'>
export type DonationBoxId = AbstractId<'donation-box'>

export enum DonationBoxStatus {
  Active = 'active',
  Cancelled = 'cancelled'
}

export interface DonationFormAmountOptions {
  low: number
  medium: number
  high: number
}

export interface RecentDonation {
  createdAt: Dayjs
  amount: number

  isAnonymous: boolean
  firstname: string | null
  lastname: string | null

  comments: string | null
}

export interface DonationBox {
  id: DonationBoxId
  userId: UserId
  status: DonationBoxStatus
  mailUpdatesAccepted: boolean
  slug: string
  title: string
  description: string
  donationGoalAmount: number
  coverPhoto: CmsMediaFile
  donationAmountOptions?: Partial<DonationFormAmountOptions>
}

export interface WebsiteDonationBox {
  totalAmount: number
  totalDonations: number
  highestDonation: number
  userName: string
  recentDonations: RecentDonation[]
}

export interface CreateOrUpdateDonationBoxParams {
  userId: UserId
  coverPhotoId: CmsMediaFileId | undefined
  coverPhoto: File | undefined
  mailUpdatesAccepted: boolean
  slug: string
  title: string
  description: string
  donationGoalAmount: number
  plannedAt: Dayjs | null
  status: DonationBoxStatus
}

export interface DonationStatistics {
  id: DonationId
  cookedMeals: number
  donationsThisYear: number
  newMatches: number
  newMatchesThisYear: number
  recentDonations: RecentDonation[]
}
